import Tdg_OrganisationModelBase from '../_generated/modelBases/tdg-organisation-model-base';

// eslint-disable-next-line @typescript-eslint/naming-convention
export default class Tdg_OrganisationModel extends Tdg_OrganisationModelBase {
  logoDocumentExternalId: string | undefined;
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
